// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".navigation{border-bottom:1px solid var(--color-border-thin)!important}.navigation i{color:var(--color-icon)}.navigation .v-list-item--active .v-list-item__content{color:var(--v-primary-base);font-weight:700}.navigation .v-list-item--active i{color:var(--v-primary-base)}.navigation .v-list-item--active:before{background:none}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
